import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { AuthService } from "../../services/auth.service";

@Component({
  selector: "app-landing",
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: "./landing.component.html",
  styleUrl: "./landing.component.css"
})
export class LandingComponent implements OnInit {
  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl("/problems");
    }
  }
}
